import { render, staticRenderFns } from "./BrowserNotificationTutorialModal.vue?vue&type=template&id=024c3e98"
import script from "./BrowserNotificationTutorialModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowserNotificationTutorialModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports